module.exports = __webpack_public_path__ + "static/img/20.5fcce08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/20.jpg
// module id = emvl
// module chunks = 1